import { idSchema } from '@/lib/utils'
import { z } from 'zod/v4'

export const customerReviewIdSchema = z.object({
  customerReviewId: idSchema('customer-review'),
})
